<!-- 此component用來主頁面Table的操作 -->
<template id="Table">
	<section>
		<el-row v-if="tags.length > 0" class="tag-bar">
			<div v-for="tag in tags"  :key="tag" @click="clickTag(tag)"
			class="keyword-tag unselectable" :class="tag === selectedTag ? 'selected-tag' : ''" >
				{{ tag }}
			</div>
		</el-row>
		<el-col :span="24" v-if="this.$store.state.resourceList.author" class="author-bar">
			「 {{ authorName }} 」作者的主題&nbsp;
			<el-popover placement="bottom-start" width="564" trigger="manual" v-model="authorsVisible">
				<div class="authorsPopover">
					<div v-for="obj in authors" :key="obj.name" class="authorDiv" @click="clickAuthor(obj.name, obj.user.displayname)">
							{{ obj.user.displayname }} 
					</div>
				</div>
				<el-button type="text" slot="reference" :loading="authorsLoading" @click="getAuthors">更多熱門作者</el-button>
  			</el-popover>			
		</el-col>
		<el-col :span="24" v-else class="filter-bar">
			<el-button v-show="getDepReady === true" class="filter-btn" type="primary" @click="getFilterList">進階篩選
				<img src="../../assets/icon/ic_filter.png" alt="F" class="icon">
			</el-button>
			<div>
				<checkFilter ref="checkFilter" v-show="this.$store.state.isShowCheckFilter" @setURL="setURL"></checkFilter>
			</div>
			<p class="filter-content"></p>
    		<v-tag-editor v-model="this.$store.state.checkedFilterLists" @setURL="setURL" theme="bulma"></v-tag-editor>
    		<div v-if="this.$store.state.checkedFilterLists.length > 0" class="clear-all-filter" @click="clearAllFilters">清除所有條件</div>
		</el-col>
		<!--工具条-->
		<el-col v-show="this.$store.state.isBackendMode" :span="24" class="tool-bar">
			<el-button v-show="!this.$store.state.isSystemAdminMode" class="fn-btn add-btn" @click="addFile">新增
				<img src="../../assets/icon/ic_add.png" alt="A" class="add-icon">
			</el-button>
			<el-button class="fn-btn export-btn" :loading="csvLoading" @click="getCSVData">
				匯出CSV
			</el-button>
			<downloadCsv ref="downloadCsv" :data = "jsonData" name = "data.csv" style="display: none;"></downloadCsv>
			<el-tooltip v-if="!allowDelete"  effect="light" content="僅可刪除所管理部門的主題" placement="top">
				<el-button class="fn-btn delete-btn" style="cursor:not-allowed;">刪除
					<img src="../../assets/icon/ic_delete_white.png" alt="D" class="delete-icon">
				</el-button>
			</el-tooltip>
			<el-button v-else v-show="sels.length > 0" class="fn-btn delete-btn" @click="deleteMultiFile(sels)">刪除
				<img src="../../assets/icon/ic_delete_white.png" alt="D" class="delete-icon">
			</el-button>
			<el-button v-if="this.$store.state.isSystemAdminMode && sels.length === 1" class="fn-btn delete-btn" @click="enableResource(sels)">
				{{ sels[0].enable === 0 ? "上架" : "下架" }}
			</el-button>
			<el-button v-if="!this.$store.state.isSystemAdminMode" v-show="sels.length > 0" class="fn-btn" @click="addCourse(sels, 0)">
				設為選修
			</el-button>
			<el-button v-if="!this.$store.state.isSystemAdminMode" v-show="sels.length > 0" class="fn-btn" @click="addCourse(sels, 1)">
				設為必修
			</el-button>
		</el-col>

		<el-col :span="24" class="page-bar">
			<div class="total-results"> {{totalResult}} </div>
			<el-pagination v-if="resources.length > 0" layout="prev, pager, next" prev-text="prev" next-text="next" :current-page="this.$store.state.resourceList.currentPage" @current-change="handleCurrentChange" :page-size="this.$store.state.resourceList.count" :total="this.$store.state.resourceList.total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--搜尋狀態且無結果-->
		<div v-if="resources.length === 0 && this.$store.state.isHaveSearchKeyword" class="search-no-item">
			<img src="../../assets/icon/ic_nofound.png" alt="N" class="nofound-icon">
			<div class="title-no-item">抱歉，我們找不到您搜尋的項目</div>
			<div class="vice-title-no-item">請嘗試不同的搜尋詞</div>
		</div>

		<!--列表-->
		<el-table v-else :data="resources" 
		          v-loading="listLoading" 
							empty-text="暫無數據"
							@select="selectRow" 
							@selection-change="selsChange" 
							@row-click="rowClick" 
							@sort-change="sortChange"
							style="min-width: 100%;">
			<el-table-column min-width="3%" v-if="this.$store.state.isBackendMode" type="selection" >
			</el-table-column>
			<el-table-column min-width="14%" v-if="this.$store.state.isBackendMode" prop="code" label="編號" sortable="custom">
			</el-table-column>
			<el-table-column min-width="43%" prop="title" label="主題" class="title-column" sortable="custom"> 
				<template slot-scope="scope">	
					{{ scope.row.title  }} 
					<div class="tableCompulsory" v-if="scope.row.course_type === 1">必修</div>
              		<div class="tableElective" v-if="scope.row.course_type === 0">選修</div>
				</template>
			</el-table-column>
			<el-table-column min-width="23%" prop="department" label="部門" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="category" label="分類" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="level" label="程度" :formatter="formatLevel" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="type" label="類型" :formatter="formatType">
			</el-table-column>
			<!-- <el-table-column min-width="13%" prop="author" label="作者" :formatter="formatAuthor" sortable="custom">
			</el-table-column> -->
			<el-table-column min-width="19%" prop="rating" label="評分" sortable="custom">
				<template slot-scope="scope">	
					<StarRating v-if="resources[scope.$index].rating > 0" :rating="resources[scope.$index].rating" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
					<StarRating v-else :rating="resources[scope.$index].rating" :show-rating="false" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
				</template>
			</el-table-column>
			<el-table-column min-width="16%" prop="count" label="點擊率" sortable="custom">
			</el-table-column>
			<el-table-column min-width="16%" prop="mtime" label="更新時間" :formatter="formatMtime" sortable="custom">
			</el-table-column>
			<el-table-column v-if="resources.length > 0 && this.$store.state.isSystemAdminMode" min-width="13%" prop="enable" label="狀態" :formatter="formatEnable" sortable="custom">
			</el-table-column>
			<!--
			<el-table-column label="操作" width="150">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">編輯</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
			-->
		</el-table>
		<hint v-show="hint.display && this.$store.state.hintStatus.table" :message="hint.message" @close="closeHint"></hint>
 
	</section>
	
</template>

<script>
	import TagComponent from './Tag.vue';
	import util from '../../common/js/util';
	import API from '../../api/api';
	const ResourceEnableStatusEnum = Object.freeze({ 0:'禁用', 1:'啟用' });
	export default {
		components: {'v-tag-editor' : TagComponent},
		props: {
            categoryGroupList: {
                type: Array
            }
        },
		name: 'Table',
		data() {
			return {
				isGetResources: false,
				authorName: '',
				getDepReady: false,
				csvLoading: false,
				authorsLoading: false,
				authorsVisible: false,
				rating: [],
				resources: [],
				tags: [],
				selectedTag: null,
				totalResult:'',
				listLoading: false,
				hint: {
					message: '',
					display: false,
				},
      			sels: [],
				jsonData:[],
				authors:[],
				allowDelete: true,
			}
		},
		watch: {
			'$store.state.userInfoReady': {
				immediate: true,
				handler(val) {
					if (val && !this.isGetResources
						&& (!this.$store.state.resourceList.categoryGroupId || this.$store.state.categoryGroupReady)) {
						this.isGetResources = true;
						this.getResources();
					}
				}
			},
            '$store.state.categoryGroupReady': {
                immediate: true,
                handler(val ) {
					if (val && !this.isGetResources
						&& this.$store.state.resourceList.categoryGroupId
						&& this.$store.state.userInfoReady) {
						this.isGetResources = true;
                        this.getResources();
                    }
                }
            }
        },
		methods: {
			getFilterList: function() {
				this.$store.state.isShowCheckFilter = true;
				this.$refs.checkFilter.updateFilter();
			},
			/**
			  * clearAllFilters 取消全部的filter
			  * @return none
			  */
			clearAllFilters: function() {
				this.$store.state.checkedFilterLists = [];
				this.$store.state.checkedDeps = null;
  				this.$store.state.checkedLevels = [];
  				this.$store.state.checkedTypes = [];
  				this.$store.state.checkedTimes = null;
  				this.$store.state.checkedSecrets = [];
  				this.$refs.checkFilter.updateFilter();
  				this.$store.state.resourceList.currentPage = 1;
      			this.$store.state.resourceList.offset = 0;
  				this.$emit('setURL');
			},
			getResourcesParams(type = null) {
				var getResourcesParams = {
					categoryId: this.$store.state.resourceList.categoryId,
					actual_depid: this.$store.state.resourceList.actual_depid,
					level: this.$store.state.resourceList.level,
					type: this.$store.state.resourceList.type,
					author: this.$store.state.resourceList.author,
					secret: this.$store.state.resourceList.secret,
					start: this.$store.state.resourceList.startTime,
					end: this.$store.state.resourceList.endTime,
					size: this.$store.state.resourceList.count,
					offset: this.$store.state.resourceList.offset,
					keyword: this.$store.state.resourceList.keyword,
					tag: this.$store.state.resourceList.tag,
					order: this.$store.state.resourceList.order,
					by: this.$store.state.resourceList.by,
					enable: this.$store.state.resourceList.enable,
				}
				// ignore categoryId and checkFilter setting while filter by author
				if (getResourcesParams.author) {
					getResourcesParams.categoryId = null;
					getResourcesParams.actual_depid = null;
					getResourcesParams.level = null;
					getResourcesParams.type = null;
					getResourcesParams.start = null;
					getResourcesParams.end = null;
				}
				// get categoryId from categoryGroupId
				if(this.$store.state.resourceList.categoryGroupId) {
					for(let i = 0 ; i < this.categoryGroupList.length ; i++) {
						if (this.categoryGroupList[i].id === this.$store.state.resourceList.categoryGroupId ) {
							getResourcesParams.categoryId = [];
							for (let j = 0 ; j < this.categoryGroupList[i].category.length ; j++) {
								getResourcesParams.categoryId.push(this.categoryGroupList[i].category[j].id);
							}
						} 
					}
					if(!getResourcesParams.categoryId || getResourcesParams.categoryId.length === 0) {
						getResourcesParams.categoryId = [9999];
					}
				}
				
				if (type === 'csv') {
					getResourcesParams.size = 9999;
					getResourcesParams.offset = null;
				}

				if (!this.$store.state.isSystemAdminMode) {
					getResourcesParams.enable = 1;
				}

				return getResourcesParams;
			},
			getResources() {
				this.$store.state.isHaveSearchKeyword = false;
				this.listLoading = true;
				this.resources.length = 0;
				this.authorName =  ''
				this.tags.length = 0;
				this.selectedTag = null;
				
				API.getResources(this.getResourcesParams()).then((response) => {
					if(!response) {
						this.listLoading = false;
						this.showHint('取得資源錯誤!');
					} else {
						if(response.status) {
							redirectLogin(response.data);
							this.listLoading = false;
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('取得資源錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.listLoading = false;
							if (this.$store.state.resourceList.author &&
							 this.$store.state.resourceList.authorName) {
								this.authorName = this.$store.state.resourceList.authorName;
							} 
							
							if (!this.$store.state.resourceList.author &&
							 this.$store.state.resourceList.keyword === '') {
								this.tags = response.tags.map(o => o.tag);
								this.selectedTag = this.$store.state.resourceList.tag;
							}
							//全部筆數
							this.$store.state.resourceList.total = response.total;
							//目前頁數
							this.$store.state.resourceList.currentPage = 
							(this.$store.state.resourceList.offset / this.$store.state.resourceList.count) + 1;
							//資源列表顯示結果字串
							if(this.$store.state.resourceList.total === 0) {
								this.totalResult = ' 共 ' + this.$store.state.resourceList.total + ' 筆結果';
							} else {
								this.totalResult = this.$store.state.resourceList.count * (this.$store.state.resourceList.currentPage - 1) 
																+ 1 + ' - ' + 
																(this.$store.state.resourceList.count * (this.$store.state.resourceList.currentPage - 1) 
																+ response.result.length) + ' 筆，' + ' 共 ' + this.$store.state.resourceList.total + ' 筆結果';
							}
			
							for(let i = 0 ; i < response.result.length ; i++) {
								let resourceObj = {};
								resourceObj.id = response.result[i].id;
								resourceObj.actual_depid = response.result[i].actual_dep.id;
								resourceObj.code = response.result[i].code;
								resourceObj.title = response.result[i].title;
								resourceObj.department = response.result[i].actual_dep ? 
								response.result[i].actual_dep.name : "";
								resourceObj.category = response.result[i].category.title;
								resourceObj.course_type = response.result[i].course_type;
								resourceObj.level = response.result[i].level;
								resourceObj.type = response.result[i].fileAttrs;
								resourceObj.secret = response.result[i].secret;
								resourceObj.mtime = response.result[i].mtime;
								resourceObj.author = response.result[i].author;
								resourceObj.count = response.result[i].count;
								resourceObj.enable = response.result[i].enable;
								if (this.authorName ===  '' && i === 0) {
									this.authorName = response.result[i].author.displayname;
								}
								if(response.result[i].rating) {
									resourceObj.rating = Math.ceil(response.result[i].rating.average*10)/10;
								} else {
									resourceObj.rating = 0;	
								}
								resourceObj.fileAttrs = response.result[i].fileAttrs; 
								this.resources.push(resourceObj);
							}

							if(this.$store.state.resourceList.keyword === '') {
								this.$store.state.isHaveSearchKeyword = false;
							} else {
								this.$store.state.isHaveSearchKeyword = true;	
							}
						}
					}
				});
			},
			/**
			  * formatType 資源類型轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  type   - 資源類型
    		  */
			formatType(row, column) {
				return util.resourceInfo.formatType(row.type);
			},
			/**
			  * formatLevel 資源程度轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  type   - 資源類型
    		  */
			formatLevel: function (row, column) {
				return 'L ' + row.level;
			},
			/**
			  * formatAuthor 作者轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  author - 作者
    		  */
			formatAuthor: function (row, column) {
				return row.author.displayname;
			},
			/**
			  * formatMtime 資源編輯時間轉換
			  * @param  {object}  row    - row
			  * @param  {object}  column - column
			  * @return {string}  mtime  - 資源編輯時間
    		  */
			formatMtime: function (row, column) {	
				if(row.mtime === null || row.mtime === 0 || row.mtime === undefined) {
					return '-';
				}

				return util.formatDate.format(new Date(row.mtime), 'yyyy-MM-dd');
			},
			formatEnable: function (row, column) {
				let statusDesc = this.formatEnableDesc(row.enable);
				return statusDesc;
			},
			formatEnableDesc: function (enableStatus) {
				return ResourceEnableStatusEnum[enableStatus];
			},
			/**
			  * handleCurrentChange 列表頁數切換
			  * @param  {number}  val - 切換到的頁數
			  * @return none
    		  */
			handleCurrentChange(val) {
				//update currentPage
				this.$store.state.resourceList.currentPage = val;
				//update offset
				this.$store.state.resourceList.offset = this.$store.state.resourceList.count * (this.$store.state.resourceList.currentPage - 1);
				//取得資源列表
				this.getResources();
			},
			selectRow: function (selection, row) {
				
			},
			selsChange: function (sels) {
				this.sels = sels;
				if (!this.$store.state.isSystemAdminMode) {
					this.allowDelete = true;
					for (let i = 0; i < sels.length;i++) {
						if (sels[i].actual_depid != this.$store.state.userActualDepId) {
							this.allowDelete = false;
						}
					}
				}
			},
			/**
			  * sortChange 排序切換
			  * @param  {column}  object - columnobject
			  * @return none
    		  */
			sortChange: function(column, prop, order) {	
				//update sort order
				if(column.order === 'descending') {
					this.$store.state.resourceList.order = 'desc';	
				} else if(column.order  === 'ascending') {
					this.$store.state.resourceList.order = 'asc';	
				} else {
					this.$store.state.resourceList.order = null;		
				}

				//update sort by
				this.$store.state.resourceList.by = column.prop;

				//取得資源列表
				this.getResources();
			},
			rowClick: function(row, event) {
				if(event.target.nodeName === 'SPAN' || event.target.nodeName === 'INPUT') {
					return;
				}
				this.$store.state.barBreadcrumbs = [];
				this.$router.push({ path: '/info/' +  row.id});
			},
			addFile: function() {
				this.$router.push({ path: '/edit/'});
				this.$store.state.editResourceId = [];
				this.$store.state.editResourceFileAttrs = [];
				this.$store.state.editResource.fileIds = [];
				this.$store.state.editResource.keywords = [];
				this.$store.state.editResource.title = '';
				this.$store.state.editResource.description = '';
				this.$store.state.editResource.categoryId = 0;
				this.$store.state.editResource.depId = null;
				this.$store.state.editResource.level = 1;
				this.$store.state.editResource.secret = 0;
			},
			deleteMultiFile: function(files) {
				this.$confirm('確定刪除選中資源嗎 ?', '提示', {
					confirmButtonText: '確定',
          			cancelButtonText: '取消',
				}).then(() => {
					let completeTimes = 0;
					for(let i = 0 ; i < files.length ; i++) {
						//delete temp file
						API.deleteResource(files[i].id).then((response) => {
							if(response.status) {
								redirectLogin(response.data);
								if(!JSON.parse(response.request.response).error_msg) {
									this.showHint('刪除資源錯誤!');
								} else {
									this.showHint(JSON.parse(response.request.response).error_msg);
								}
							} else {
								if (files[i].fileAttrs.length > 0) {
									for(let j = 0 ; j < files[i].fileAttrs.length ; j++) {
										//delete true file
										API.deleteResourceFromJustup(files[i].fileAttrs[j].fileid).then((result) => {
											completeTimes++;
											if(result.status) {
												redirectLogin(result.data);
												if(!JSON.parse(result.request.response).error_msg) {
													this.showHint('刪除資源錯誤!');
												} else {
													this.showHint(JSON.parse(result.request.response).error_msg);
												}
											} else {
												if(completeTimes === files[i].fileAttrs.length ) {
													//this.hint.message = '刪除資源成功';
													//this.hint.display = true;	
													location.reload();		
												}
											}
										});
									}	
								} else {
									completeTimes++;
									if(completeTimes === files[i].fileAttrs.length) {
										location.reload();	
									}
								}
							}
						});
					}
				}).catch(() => {});
			},
			enableResource(sels) {
				let resourceObj = sels[0];
				let newEnableStatus = !Boolean(resourceObj.enable);
				this.listLoading = true;

				API.enableResource(resourceObj.id, newEnableStatus).then((response) => {
					if(!response) {
						this.listLoading = false;
						this.showHint('錯誤!');
					} else {
						this.listLoading = false;
						resourceObj.enable = + newEnableStatus;
					}
				});
			},
			async addCourse(sels, type) {
				this.listLoading = true;
				for(let i = 0 ; i < sels.length ; i++) {
					await API.addCourses({
						resource_id: sels[i].id,
						actual_depid: this.$store.state.userActualDepId,
						type: type,
					}).then((response) => {
						if(response.status) {
							let code = JSON.parse(response.request.response).error_code;
							if (code === "ERROR_SCIENCE_COURSE_COMPULSORY_EXIST") {
								this.showHint('主題已存在必修課程!');
							} else if (code === "ERROR_SCIENCE_COURSE_ELECTIVE_EXIST") {
								this.showHint('主題已存在選修課程!');
							} else {
								this.showHint('新增課程發生錯誤!');
							}
						}
					});
				}
				this.getResources();
			},
			/**
			* setURL 設定要前往的URL
			* @return none
			*/ 
			setURL() {
				this.$emit('setURL');
			},
			/**
			  * closeHint close hint 視窗
			  * @return none
			  */
			closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.table = false;
				clearTimeout(this.timer);
			},
			/**
			  * showHint 
			  * @param  {string} message - message
			  * @return none
			  */
			showHint: function(message) {
				if(this.timer) {
					clearTimeout(this.timer);	
				}
				this.hint.display = true;
				this.hint.message = message;	
				this.$store.state.showHint = true;
				this.$store.state.hintStatus.table = true;
				this.timer = setTimeout(()=>{
					if(this.$store.state.showHint) {
						this.$store.state.showHint = false;
						this.$store.state.hintStatus.table = false;
					}
        		}, this.$store.state.fadeOutTime);
			},
			async getCSVData() {
				this.csvLoading = true;
				this.jsonData.length = 0;
				await API.getResources(this.getResourcesParams('csv')).then((result) => {
					if (result.result.length > 0) {
						for(let i = 0 ; i < result.total ; i++) {
							let item = { 
								title: '',
								'部門': '',
								'作者': '',
								category: '',
								level: '',
								type: '',
								'點擊率': '',
								time: '',
								'狀態': ''
							};
							item.title = result.result[i].title;
							item.部門 = result.result[i].actual_dep.name;
							item.作者 = result.result[i].author.displayname;
							item.category = result.result[i].category.title;
							item.level = 'L ' + result.result[i].level;
							item.點擊率 = result.result[i].count;
							item.狀態 = this.formatEnableDesc(result.result[i].enable);

							let haveVideo = false;
							let haveDoc = false;
							if(result.result[i].fileAttrs.length > 0) {
								for(let j = 0 ; j < result.result[i].fileAttrs.length ; j++) {
									if(result.result[i].fileAttrs[j].type === 'video') {
										haveVideo = true;	
									} else if(result.result[i].fileAttrs[j].type === 'doc') {
										haveDoc = true;
									}
								}

								if(haveVideo && haveDoc) {
									item.type = '影片、文件';
								} else if(haveVideo) {
									item.type = '影片';
								} else if(haveDoc) {
									item.type = '文件';
								} else {
									item.type = '無';
								}
							} else {
								item.type = '無';
							}

							let date = new Date(result.result[i].mtime);
							let year = date.getFullYear();
							let month = date.getMonth() + 1;
							let day = date.getDate();

							if(month < 10) {
								month = '0' + month;
							}

							if(day < 10) {
								day = '0' + day;
							}

							item.time = year + '-' + month + '-' + day;
							this.jsonData.push(item);
						}	
					} else {
						this.jsonData.push({ "查無資料": null});
					}
				});
				this.$refs.downloadCsv.generate();
				this.csvLoading = false;
			},
			async getAuthors() {
				if (this.authors.length === 0) {
					this.authorsLoading = true;
					let now = new Date();
					await API.getPopularAuthors([], 0, now.getTime()).then((result) => {
						if (!result) {
							this.showHint("取得熱門作者錯誤!");
						} else {
							this.authors = 
							result.filter( obj => obj.name != this.$store.state.resourceList.author);
						}
					});
					this.authorsLoading = false;
				}
				this.authorsVisible = !this.authorsVisible;
			},
			clickAuthor(name, displayName) {
				this.$emit('setAuthorList', name, displayName);
				this.authors.length = 0;
				this.authorsVisible = false;
			},
			clickTag(tag) {
				if (this.selectedTag === tag) {
					this.selectedTag = null;
				} else {
					this.selectedTag = tag;
				}
				this.$store.state.resourceList.tag = this.selectedTag;
				this.$store.state.resourceList.currentPage = 1;
				this.$store.state.resourceList.offset = 0;
				this.setURL();
			},
		},
		beforeCreate() {
			this.$store.state.isHaveSearchKeyword = false;
			//取得部門資料
			API.getActualDeps().then((response) => {
				if(response.status) {
					if(!JSON.parse(response.request.response).error_msg) {
						this.showHint('取得真實部門資料錯誤!');
					} else {
						this.showHint(JSON.parse(response.request.response).error_msg);	
					}
				} else {
					this.$store.state.actualDeps = response.result;
					let actualDepsAll = response.result;
					let actualDepsDict = actualDepsAll.reduce((result, actualDepsAll) => {
						result[actualDepsAll.id] = {
							value: actualDepsAll.id,
							label: actualDepsAll.name
						};
						return result;
					},{});
					API.getdDepartmentList().then((response) => {
						if(response.status) {
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('取得部門資料錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.$store.state.actualDepsOptions = [];
							this.$store.state.checkedDeps = null;
							let depsAll = response.result;
							for (let i = 0; i < depsAll.length; i++) {
								const dep = depsAll[i];
								let option = { value: dep.id, label: dep.title };
								option.children = actualDepsAll
								.filter(dep => dep.depid === option.value)
								.map(dep => actualDepsDict[dep.id]);
								this.$store.state.actualDepsOptions.push(option);
							}
							this.getDepReady = true;
						}
					});
				}
			});
		},
		created() {
			this.$store.state.nowStatus = 0;
		},
		beforeRouteUpdate: function (to, from, next) {
			next();
			this.getResources();
		},
	}

</script>

<style lang="scss">
	.tag-bar {
		display: flex;
		flex-wrap: wrap;
  		line-height: 34px;
		color: #2E90F4;
		font-size: 14px;
		margin-top: -15px;

		.keyword-tag {
			white-space: nowrap;
			background-color: #FFFFFF;
			border: 1px solid #DCDACC;
  			border-radius: 17px;
			padding: 0px 15px 0px 15px;
			margin-right: 10px;
			margin-top: 10px;
			cursor: pointer;
		}

		.selected-tag {
			background-color: #2E90F4;
			color:#FFFFFF;
		}
	}

	.author-bar {
		background-color: #F5F8FA;
		color: #3C3B38;
		font-size: 24px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 24px;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.authorsPopover {
		padding: 10px;
	}

	.authorDiv {
		display: inline-block;
		box-sizing: border-box;
  		height: auto;
  		width: auto;
  		border: 1px solid #DCDACC;
  		border-radius: 3px;
		cursor: pointer;

		padding: 8px 24px 8px 24px;
		margin: 5px;

		color: #2E90F4;
		font-size: 14px;
		letter-spacing: 0;
		line-height: 24px;
		text-align: center;
	}

	.authorDiv:hover {
		background: #F0F7FF;
		border: 1px solid #2E90F4;
	}

	.filter-bar {
		text-align: center;
		height: 60px;
		width: 100%;
		background-color: #F5F8FA;

		.filter-btn {
			float: left;
			background-color: #ffffff;
			border: 1px solid #EEEEEE;
			display: block;
			border-radius: 2px;
			position: relative;
			margin-top: 10px;
			color: #626874;
			font-size: 14px;
			line-height: 20px;
			height: 40px;
			width: 104px;
			z-index: 2;
		}
		.icon {
			display: inline-block;
			vertical-align: middle;
			width: 16px;
			height: 16px;
		}	
	}
	.clear-all-filter {
		float: left;
		margin-top: 4px;
		margin-left: 13px;
	    font-size: 14px;
	    color: #2E90F4;
	    cursor: pointer;
	    line-height: 24px;
	}

	.tableCompulsory {
		display: inline-block;
		border-radius: 2px;
		color: #593C00;
		background-color: #FFE799;
		padding: 0px 8px 0px 8px;
	}

	.tableElective {
		display: inline-block;
		border-radius: 2px;
		color: #035C81;
		background-color: #ADEBFB;
		padding: 0px 8px 0px 8px;
	}

	.el-table {
		cursor: pointer;
		color: #626874;
		font-size: 14px;
	}

	.el-table::before {
		height: 0px;
	}

	.el-icon-arrow-left::before {
		content : "❮";
		display: block;
	}

	.el-icon-arrow-right::before {
		content : "❯";
		display: block;
	}

	.el-icon-more:before {
		content : "⋯";
		display: block;	
	}

	.el-icon-d-arrow-left::before {
		content : "⟪";
		display: block;
	}

	.el-icon-d-arrow-right::before {
		content : "⟫";
		display: block;
	}

	.el-table__header-wrapper thead div {
		background-color: #fff;
	}
	.el-table th {
		background-color: #fff;	
	}

	.el-table--enable-row-hover .el-table__body tr input[type=checkbox] {
		background-color: #F0F7FF !important;
		border-top: 1px solid #2E90F4 !important;
		border-bottom: 1px solid #2E90F4 !important;
		color: #1C6BBC !important;	
		z-index: 2;
	}
	
	.el-table--enable-row-hover .el-table__body tr:hover td {
		background-color: #F0F7FF !important;
		border-top: 1px solid #2E90F4 !important;
		border-bottom: 1px solid #2E90F4 !important;
		color: #1C6BBC !important;
		z-index: 2;
	}

	.el-table--enable-row-hover .el-table__body tr:hover td:first-child {
		border-left: 1px solid #2E90F4 !important;
		z-index: 2;
	}

	.el-table--enable-row-hover .el-table__body tr:hover td:last-child {
		border-right: 1px solid #2E90F4 !important;
		z-index: 2;
	}

	.el-table .caret-wrapper {
		width: 32px;
    	height: 36px;
	}

	.el-table .sort-caret.ascending {
		border-bottom: 7px solid #97a8be;
	}

	.el-table .sort-caret.descending {
		border-top: 7px solid #97a8be;
	}
	.star-rating {
		font-size: 10px;
		margin-bottom: 8px;  
	}

	.tool-bar {
		height: 54px;
		background: #FFFFFF;
		border-top: 1px solid #EEE;
		border-left: 1px solid #EEE;
		border-right: 1px solid #EEE;

		.fn-btn {
			float: right;
			display: block;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			border: none;
			margin-top: 9px;
			white-space: normal;
		}

		.fn-btn:hover {
    		background: #42A0FF;
		}

		.add-btn {
			margin-left: 10px;
			width: 92px;
			.add-icon {
				height: 14px;
				width: 14px;
				float: left;
			}
		}

		.export-btn {
			padding: 9px 9px 9px 19px;
			width: 92px;
		}

		.delete-btn {
			margin-left: 10px;
			width: 92px;
			.delete-icon {
				height: 14px;
				width: 14px;
				float: left;
			}
		}

		.menu-select {
			display: block;
			float: left;
			max-width: 18vw;
			margin-left: 20px;
			text-align: center;

			.el-input__inner{
				border-color: #B6B6B6;
				background-color: #F5F5F5;
				border-radius: 2px;
				font-size: 14px;
				font-weight: 500;
				color: #222;
				line-height: 24px;
				margin-top: 9px;	
			}
	
			.el-input__icon{
					width: 40px;
					margin-top: 4px;
					color: #626874;
			}
		
			.el-input__suffix {
					&:before{
						content: '';
						position: absolute;
						left: 0;
						height: 32px;
						width: 1px;
						background-color: rgba(151, 151, 151, .35);
						margin-top: 7px;
					}
			}

			.el-icon-arrow-up {
					&:before {
						color: #a7a7a7;
						content: '\25B2';
					}
			}
		}	
	}
	.page-bar {
		background: #ffffff;
		height: 48px;
		border-left: 1px solid #EEE;
		border-right: 1px solid #EEE;
		border-top: 1px solid #EEE;
    	//padding: px;
    	//margin: 5px 0px;
		.total-results {
			display: block;
			float: left;
			font-size: 14px;
			display: table-cell;
			vertical-align: middle;
			line-height: 24px;
			margin-top: 12px;
			margin-left: 20px;
			font-weight: 500;
			//padding: 0 5px;
			color: #626874;
		}
		.el-pagination {
			margin-top: 8px;	
			line-height: 24px;
			margin-right: 15px;
		}	
	}
	.search-no-item {
		background-color: #ffffff;
		width: 100%;
		height: 600px;
		border: 1px solid #EEE;
		margin-left: -1px;
		.nofound-icon {
    	vertical-align: middle;
    	text-align: center;
    	width: 70px;
    	height: 70px;
    	display: table;
  		margin: 152px auto;
		}
		.title-no-item {
			color: #222222;
			text-align: center;
			margin-top: -100px;
			font-size: 18px;
		}
		.vice-title-no-item {
			color: #626874;
			text-align: center;
			font-size: 14px;
		}
	}
</style>


// WEBPACK FOOTER //
// Table.vue?aa198fc4